import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <section className="pt-20 md:pt-24 pb-8 md:pb-12 bg-background-100">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="flex items-center gap-2 mb-4">
              <a href="/" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors flex items-center gap-1">
                <i className="ri-home-line w-3 h-3 flex items-center justify-center" /> Home
              </a>
              <span className="text-foreground-300">/</span>
              <span className="text-xs text-primary-600 font-medium">Privacy</span>
            </div>
            <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-4 leading-tight">
              Privacy <span className="text-primary-500">Policy</span>
            </h1>
          </div>
        </div>
      </section>

      <section className="w-full py-12 md:py-16">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-xl border border-background-200 p-6 md:p-8 lg:p-10">
              <div className="prose prose-sm max-w-none text-foreground-600 leading-relaxed">
                <p className="mb-4">
                  At CSSBuyBR.info, we respect your privacy and are committed to protecting any information you may share with us. This Privacy Policy outlines how we handle data on our website.
                </p>
                <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mt-8 mb-4">Information We Collect</h2>
                <p className="mb-4">
                  CSSBuyBR.info is primarily an informational website. We do not actively collect personal information from visitors. However, like most websites, we may collect standard log information including:
                </p>
                <ul className="space-y-2 mb-6 list-disc list-inside">
                  <li>IP address and browser type</li>
                  <li>Pages visited and time spent on the site</li>
                  <li>Referring website addresses</li>
                  <li>General geographic location (country/region level)</li>
                </ul>
                <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mt-8 mb-4">How We Use Information</h2>
                <p className="mb-4">
                  Any data collected is used solely for website analytics and improving user experience. We do not sell, trade, or transfer your information to third parties. We do not use your data for marketing purposes.
                </p>
                <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mt-8 mb-4">Cookies</h2>
                <p className="mb-4">
                  This website may use cookies to enhance your browsing experience. Cookies are small files stored on your device that help us understand how visitors use our site. You can disable cookies in your browser settings if you prefer.
                </p>
                <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mt-8 mb-4">Third-Party Links</h2>
                <p className="mb-4">
                  Our website contains links to external websites, including CSSBuy and other third-party services. We are not responsible for the privacy practices of these external sites. We encourage you to read their privacy policies when visiting them.
                </p>
                <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mt-8 mb-4">Changes to This Policy</h2>
                <p className="mb-4">
                  We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated date. We recommend checking this page periodically for any updates.
                </p>
                <div className="p-4 bg-amber-50 border border-amber-200 rounded-lg mt-8">
                  <p className="text-sm text-amber-800">
                    Last updated: August 30, 2026. If you have any questions about this Privacy Policy, please contact us.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}